var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsDoubleSwNe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrows-double-sw-ne"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7071 2.29289C15.0976 2.68342 15.0976 3.31658 14.7071 3.70711L5.41421 13H7C7.55228 13 8 13.4477 8 14C8 14.5523 7.55228 15 7 15H3C2.44772 15 2 14.5523 2 14V10C2 9.44772 2.44772 9 3 9C3.55228 9 4 9.44772 4 10V11.5858L13.2929 2.29289C13.6834 1.90237 14.3166 1.90237 14.7071 2.29289ZM17 11C16.4477 11 16 10.5523 16 10C16 9.44772 16.4477 9 17 9H21C21.5523 9 22 9.44772 22 10V14C22 14.5523 21.5523 15 21 15C20.4477 15 20 14.5523 20 14V12.4142L10.7071 21.7071C10.3166 22.0976 9.68342 22.0976 9.29289 21.7071C8.90237 21.3166 8.90237 20.6834 9.29289 20.2929L18.5858 11H17Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsDoubleSwNe);
export default __webpack_public_path__ + "static/media/arrows-double-sw-ne.ab752a0de176f828496feff82e816602.svg";
export { ForwardRef as ReactComponent };